import React, { Component } from "react";
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, LineController, LineElement, PointElement, LinearScale, Title, BarController, BarElement, DoughnutController, Legend, Tooltip } from 'chart.js';
import { Chart } from 'chart.js';
import { CategoryScale, ArcElement } from 'chart.js';
import axios from 'axios';
import bufferImage5 from '../../assets/images/samples/buffer_image5.jpg';

ChartJS.register(LineController, LineElement, PointElement, LinearScale, Title, ArcElement, BarController, BarElement, DoughnutController, Legend, Tooltip);
Chart.register(CategoryScale);


const API_BASE_URL = "http://selectree-docker-rufa-dev-env.us-west-2.elasticbeanstalk.com";
const RUFA_GLOBAL_ENDPOINT = `${API_BASE_URL}/api/rufa/city/global`;
const ARRAY_CUT_OFF = 5;
const COLORS = ["#61854e", "#6d597a", "#354f52", "#8B4513", "#e09f3e", "#b56576", "#4682B4", "#9e2a2b", "#ecc8af", "#e26d5c", "#c9cba3", "#f28f3b"];

const calculateCategoryCount = (total, items) => {
  const topItems = items.slice(0, ARRAY_CUT_OFF);
  const sumTopItemsCount = topItems.reduce((sum, item) => sum + item.total_count, 0);
  const otherCount = total - sumTopItemsCount;
  return {
    otherCount,
    topItems,
  };
};

export class Dashboard extends Component {
  state = {
    trees: 0,
    genera: 0,
    familes: 0,
    species: 0,
    speciesDistributionData: {
      labels: [],
      datasets: [{
        data: [],
        backgroundColor: [],
      }]
    },
    genusDistributionData: {
      labels: [],
      datasets: [{
        data: [],
        backgroundColor: [],
      }]
    },
    familyDistributionData: {
      labels: [],
      datasets: [{
        data: [],
        backgroundColor: [],
      }]
    },
    treeShapeDistributionData: {
      labels: [],
      datasets: [{ data: [], backgroundColor: [] }],
    },
    foliageTypeDistributionData: {
      labels: [],
      datasets: [{ data: [], backgroundColor: [] }],
    },
    densityInLeafDistributionData: {
      labels: [],
      datasets: [{ data: [], backgroundColor: [] }],
    },
    longevityDistributionData: {
      labels: [],
      datasets: [{ data: [], backgroundColor: [] }],
    },
    waterRatingDistributionData: {
      labels: [],
      datasets: [{ data: [], backgroundColor: [] }],
    },
  };

  async fetchData() {
    try {
      const globalResponse = await axios.get(RUFA_GLOBAL_ENDPOINT);
      const data = globalResponse.data;

      const trees = data.totalTrees;
      const genera = data.totalGenera;
      const familes = data.totalFamilies;
      const species = data.totalSpecies;

      const { otherCount: otherSpeciesCount, topItems: topSpeciesItems } = calculateCategoryCount(data.species.totalSpeciesCount, data.species.topSpecies);
      const speciesDistributionData = {
        labels: ["Other"].concat(topSpeciesItems.map(item => item.species_name)),
        datasets: [{
          data: [otherSpeciesCount].concat(topSpeciesItems.map(item => item.total_count)),
          backgroundColor: COLORS,
        }],
      };

      const { otherCount: otherGenusCount, topItems: topGenusItems } = calculateCategoryCount(data.genus.totalGeneraCount, data.genus.topGenera);
      const genusDistributionData = {
        labels: ["Other"].concat(topGenusItems.map(genus => genus.genus_name)),
        datasets: [{
          data: [otherGenusCount].concat(topGenusItems.map(genus => genus.total_count)),
          backgroundColor: COLORS,
        }],
      };

      const { otherCount: otherFamilyCount, topItems: topFamilyItems } = calculateCategoryCount(data.family.totalFamilyCount, data.family.topFamily);
      const familyDistributionData = {
        labels: ["Other"].concat(topFamilyItems.map(family => family.family_name)),
        datasets: [{
          data: [otherFamilyCount].concat(topFamilyItems.map(family => family.total_count)),
          backgroundColor: COLORS,
        }],
      };

      const { otherCount: otherTreeShapeCount, topItems: topTreeShapeItems } = calculateCategoryCount(data.treeShape.totalTreeShapeCount, data.treeShape.topTreeShapes);
      const treeShapeDistributionData = {
        labels: ["Other"].concat(topTreeShapeItems.map(item => item.tree_shape_name)),
        datasets: [{
          data: [otherTreeShapeCount].concat(topTreeShapeItems.map(item => item.total_count)),
          backgroundColor: COLORS,
        }],
      };

      const { otherCount: otherFoliageTypeCount, topItems: topFoliageTypeItems } = calculateCategoryCount(data.foliageType.totalFoliageTypeCount, data.foliageType.topFoliageTypes);
      const foliageTypeDistributionData = {
        labels: ["Other"].concat(topFoliageTypeItems.map(item => item.foliage_type_name)),
        datasets: [{
          data: [otherFoliageTypeCount].concat(topFoliageTypeItems.map(item => item.total_count)),
          backgroundColor: COLORS,
        }],
      };

      const { otherCount: otherDensityInLeafCount, topItems: topDensityInLeafItems } = calculateCategoryCount(data.densityInLeaf.totalDensityInLeafCount, data.densityInLeaf.topDensityInLeafs);
      const densityInLeafDistributionData = {
        labels: ["Other"].concat(topDensityInLeafItems.map(item => item.density_in_leaf_name)),
        datasets: [{
          data: [otherDensityInLeafCount].concat(topDensityInLeafItems.map(item => item.total_count)),
          backgroundColor: COLORS,
        }],
      };

      const { otherCount: otherLongevityCount, topItems: topLongevityItems } = calculateCategoryCount(data.longevity.totalLongevityCount, data.longevity.topLongevity);
      const longevityDistributionData = {
        labels: ["Other"].concat(topLongevityItems.map(item => item.longevity_name)),
        datasets: [{
          data: [otherLongevityCount].concat(topLongevityItems.map(item => item.total_count)),
          backgroundColor: COLORS,
        }],
      };

      const { otherCount: otherWaterRatingCount, topItems: topWaterRatingItems } = calculateCategoryCount(data.waterRating.totalWaterRatingCount, data.waterRating.topWaterRatings);
      const waterRatingDistributionData = {
        labels: ["Other"].concat(topWaterRatingItems.map(item => item.water_rating_name)),
        datasets: [{
          data: [otherWaterRatingCount].concat(topWaterRatingItems.map(item => item.total_count)),
          backgroundColor: COLORS,
        }],
      }

      this.setState({
        trees,
        genera,
        familes,
        species,
        speciesDistributionData,
        genusDistributionData,
        familyDistributionData,
        treeShapeDistributionData,
        foliageTypeDistributionData,
        densityInLeafDistributionData,
        longevityDistributionData,
        waterRatingDistributionData,

      });

    } catch (error) {
      console.error(error);
    }
  }

  doughnutOptions = {
    responsive: true,
    maintainAspectRatio: true,
    segmentShowStroke: true,
    cutoutPercentage: 70,
    elements: {
      arc: {
        borderWidth: 1,
      },
    },
    legend: {
      display: true,
    },
    tooltips: {
      enabled: true,
    },
  };

  pieOptions = {
    responsive: true,
    maintainAspectRatio: true,
    segmentShowStroke: true,
    cutoutPercentage: 70,
    elements: {
      arc: {
        borderWidth: 4,
      },
    },
    plugins: {
      legend: {
        display: true,
      }
    },
    tooltip: {
      enabled: true,
    },
  };

  sliderSettings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  componentDidMount() {
    this.fetchData();
  }

  render() {
    // render species detail sections
    let speciesDetailSections = null;
    let speciesTotalCount = 0;
    if (this.state.speciesDistributionData && this.state.speciesDistributionData.labels && this.state.speciesDistributionData.datasets) {
      speciesTotalCount = this.state.speciesDistributionData.datasets[0].data.reduce((acc, val) => acc + val, 0);
      speciesDetailSections = this.state.speciesDistributionData.labels.map((label, index) => {
        const count = this.state.speciesDistributionData.datasets[0].data[index];
        const backgroundColor = this.state.speciesDistributionData.datasets[0].backgroundColor[index] || '#ffffff';
        const percentage = ((count / speciesTotalCount) * 100).toFixed(2);

        return (
          <div key={label} className="d-flex d-md-block d-xl-flex flex-row py-3 px-4 px-md-3 px-xl-4 rounded mt-3 justify-content-between"
            style={{ backgroundColor: backgroundColor }}>
            <div className="text-md-center text-xl-left">
              <h6 className="text-white mb-1">{label}</h6>
              <p className="text-white mb-0">Total: {count}</p>
            </div>
            <div className="text-md-center text-xl-right">
              <p className="text-white mb-0">{percentage}%</p>
            </div>
          </div>
        );
      });
    }

    // render family detail sections
    let familyDetailSections = null;
    let familyTotalCount = 0;
    if (this.state.familyDistributionData && this.state.familyDistributionData.labels && this.state.familyDistributionData.datasets) {
      familyTotalCount = this.state.familyDistributionData.datasets[0].data.reduce((acc, val) => acc + val, 0);
      familyDetailSections = this.state.familyDistributionData.labels.map((label, index) => {
        const count = this.state.familyDistributionData.datasets[0].data[index];
        const backgroundColor = this.state.familyDistributionData.datasets[0].backgroundColor[index] || '#ffffff';
        const percentage = ((count / familyTotalCount) * 100).toFixed(2);

        return (
          <div key={label} className="d-flex d-md-block d-xl-flex flex-row py-3 px-4 px-md-3 px-xl-4 rounded mt-3 justify-content-between"
            style={{ backgroundColor: backgroundColor }}>
            <div className="text-md-center text-xl-left">
              <h6 className="text-white mb-1">{label}</h6>
              <p className="text-white mb-0">Total: {count}</p>
            </div>
            <div className="text-md-center text-xl-right">
              <p className="text-white mb-0">{percentage}%</p>
            </div>
          </div>
        );
      });
    }

    // render genus detail section
    let genusDetailSections = null;
    let genusTotalCount = 0;
    if (this.state.genusDistributionData && this.state.genusDistributionData.labels && this.state.genusDistributionData.datasets) {
      genusTotalCount = this.state.genusDistributionData.datasets[0].data.reduce((acc, val) => acc + val, 0);
      genusDetailSections = this.state.genusDistributionData.labels.map((label, index) => {
        const count = this.state.genusDistributionData.datasets[0].data[index];
        const backgroundColor = this.state.genusDistributionData.datasets[0].backgroundColor[index] || '#ffffff';
        const percentage = ((count / genusTotalCount) * 100).toFixed(2);

        return (
          <div key={label} className="d-flex d-md-block d-xl-flex flex-row py-3 px-4 px-md-3 px-xl-4 rounded mt-3 justify-content-between"
            style={{ backgroundColor: backgroundColor }}>
            <div className="text-md-center text-xl-left">
              <h6 className="text-white mb-1">{label}</h6>
              <p className="text-white mb-0">Total: {count}</p>
            </div>
            <div className="text-md-center text-xl-right">
              <p className="text-white mb-0">{percentage}%</p>
            </div>
          </div>
        );
      });
    }

    return (
      <div>
        <div className="d-flex align-items-center justify-content-center">
          <img src={bufferImage5} alt="Test here" style={{ height: "auto", width: "auto", position: "absolute", right: 0, top: 50 }} />
        </div>
        <b className="d-flex align-items-center justify-content-left" style={{ fontSize: "40px", position: "relative" }}>
          <mark style={{ background: "white", color: "black", borderRadius: "10px" }}>
            <span className="mdi mdi-pine-tree" style={{ marginRight: "10px", color: "#457537" }}></span>
            <strong>
              RUFA
            </strong>
            <span className="mdi mdi-pine-tree" style={{ marginLeft: "10px", color: "#457537" }}></span>
          </mark>
        </b>
        <div style={{ height: "3em" }}></div>
        <div className="row">
          <div className="col-12 grid-margin">
            <div className="card">
              <div className="card-body">
                <h2 className="card-title"> GLOBAL VIEW</h2>
                <div>
                  <h4 className="card-title">
                    Trees: {this.state.trees} |
                    Genera: {this.state.genera} |
                    Families: {this.state.familes} |
                    Species: {this.state.species}
                  </h4>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <p className="font-weight-normal text-black text-left mb-0">
                      Urban and community forestry (U&CF) programs have become critical for maintaining and enhancing urban green spaces. To bolster these efforts, there is a pressing need for sophisticated tools that aid in the assessment and reporting of U&CF activities. Recognizing this, Cal Poly proposes a comprehensive web-based reporting and assessment tool. This tool aims to amalgamate data from various sources, including the California Urban forest inventory, to produce meaningful metrics and recommendations for U&CF programs.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <h4 className="card-title">Distribution of each species</h4>
                <div className="aligner-wrapper" style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <Doughnut
                    data={this.state.speciesDistributionData}
                    options={this.doughnutOptions}
                  />

                </div>
                {speciesDetailSections}
              </div>
            </div>
          </div>
          <div className="col-md-4 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <h4 className="card-title">Foliage Type</h4>
                <div className="aligner-wrapper" style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <Doughnut
                    data={this.state.foliageTypeDistributionData}
                    options={this.doughnutOptions}
                  />

                </div>
                {familyDetailSections}
              </div>
            </div>
          </div>
          <div className="col-md-4 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <h4 className="card-title">Water Rating Distribution</h4>
                <div className="aligner-wrapper" style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <Doughnut
                    data={this.state.waterRatingDistributionData}
                    options={this.doughnutOptions}
                  />

                </div>
                {genusDetailSections}
              </div>
            </div>
          </div>

          {/* <div className="col-md-3 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <h4 className="card-title">Tree Shape</h4>
                <Pie
                    data={this.state.treeShapeDistributionData}
                    options={this.pieOptions}
                  />
              </div>
            </div>
          </div> */}
          {/* <div className="col-md-3 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <h4 className="card-title">Foliage Type</h4>
                <Pie
                    data={this.state.foliageTypeDistributionData}
                    options={this.pieOptions}
                  />
              </div>
            </div>
          </div> */}
          {/* <div className="col-md-3 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <h4 className="card-title">Tree Leaf Density</h4>
                <Pie
                    data={this.state.densityInLeafDistributionData}
                    options={this.pieOptions}
                  />
              </div>
            </div>
          </div> */}
          {/* <div className="col-md-3 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <h4 className="card-title">Tree Longevity</h4>
                <Pie
                    data={this.state.longevityDistributionData}
                    options={this.pieOptions}
                  />
              </div>
            </div>
          </div> */}
          {/* <div className="col-md-3 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <h4 className="card-title">Water Rating</h4>
                <Pie
                    data={this.state.waterRatingDistributionData}
                    options={this.pieOptions}
                  />
              </div>
            </div>
          </div> */}
        </div>
      </div>
    );
  }
}

export default Dashboard;
